import Navbar from "../../components/Navbar";
import { Helmet } from "react-helmet-async";
import Footer from "../../components/Footer";

const Agb = () => {
  return (
    <>
      <Helmet>
        <title>AGB | Elektro Thome</title>
        <link rel="canonical" href="https://energy-thome.com/agb" />
      </Helmet>
      <Navbar />
      <main style={{ padding: "1rem" }}>
        <h1>Allgemeine Geschäftsbedingungen (AGB)</h1>

        <h2>1. Geltungsbereich</h2>
        <p>
          Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge, Lieferungen und Leistungen
          zwischen <strong>Elektro Thome</strong>, Grübchenstraße 48, 66839 Schmelz, Deutschland (im Folgenden „Anbieter“)
          und unseren Kunden.
        </p>

        <h2>2. Leistungen</h2>
        <p>
          Elektro Thome bietet professionelle Elektroinstallationen und Dienstleistungen für
          Privat- und Geschäftskunden. Der genaue Leistungsumfang wird individuell vereinbart.
        </p>

        <h2>3. Vertragsschluss</h2>
        <p>
          Ein Vertrag zwischen Elektro Thome und dem Kunden kommt zustande, sobald der Kunde ein schriftliches
          Angebot annimmt oder eine mündliche Auftragsbestätigung erfolgt.
        </p>

        <h2>4. Preise und Zahlungsbedingungen</h2>
        <p>
          Alle Preise verstehen sich in Euro (€) und enthalten, sofern anwendbar, die gesetzliche Mehrwertsteuer.
          Rechnungen sind innerhalb von <strong>14 Tagen nach Rechnungsstellung</strong> ohne Abzüge zu zahlen.
        </p>

        <h2>5. Stornierung und Terminverschiebung</h2>
        <p>
          Falls ein Kunde einen Termin absagen oder verschieben muss, ist dies mindestens <strong>48 Stunden</strong> vor dem
          vereinbarten Termin mitzuteilen. Andernfalls kann eine Stornogebühr von bis zu <strong>50 % des Auftragswertes</strong> erhoben werden.
        </p>

        <h2>6. Haftung</h2>
        <p>
          Elektro Thome haftet nur für Schäden, die durch grobe Fahrlässigkeit oder Vorsatz verursacht wurden.
          Für indirekte Schäden oder Folgeschäden übernehmen wir keine Haftung.
        </p>

        <h2>7. Gewährleistung</h2>
        <p>
          Für alle erbrachten Dienstleistungen gilt eine Gewährleistungsfrist von <strong>24 Monaten</strong>, sofern nicht anders vereinbart.
          Mängel müssen unverzüglich nach deren Entdeckung schriftlich gemeldet werden.
        </p>

        <h2>8. Datenschutz</h2>
        <p>
          Elektro Thome verarbeitet personenbezogene Daten gemäß der <a href="/datenschutz">Datenschutzerklärung</a>.
          Alle Kundendaten werden vertraulich behandelt und nicht an Dritte weitergegeben.
        </p>

        <h2>9. Schlussbestimmungen</h2>
        <p>
          Es gilt das Recht der Bundesrepublik Deutschland. Sollten einzelne Klauseln dieser AGB unwirksam sein,
          bleibt die Gültigkeit der übrigen Bestimmungen unberührt.
        </p>

      </main>
      <Footer />
    </>
  );
};

export default Agb;
